import { SimpleGrid, type SimpleGridProps } from "@mantine/core";

/**
 * Responsive grid shared by all galleries and card lists.
 * Pass `cols` to tune density; spacing is consistent by default.
 */
export default function GalleryGrid({ cols, spacing = "md", children, ...props }: SimpleGridProps) {
  return (
    <SimpleGrid cols={cols ?? { base: 2, xs: 3, sm: 4, md: 5, lg: 6 }} spacing={spacing} {...props}>
      {children}
    </SimpleGrid>
  );
}
